// extracted by css-extract-rspack-plugin
export default {"tableRowActions":"uRLH6W_fOsB2a705"};